import { BrandColors } from '../theme';

export const checkboxTokens = {
    root: {
        borderRadius: '4px',
        background: BrandColors.surface[0],
        checkedBackground: BrandColors.primary[500],
        checkedHoverBackground: BrandColors.primary[600],
        disabledBackground: BrandColors.surface[100],
        borderColor: BrandColors.semantic.border,
        hoverBorderColor: BrandColors.primary[400],
        focusBorderColor: BrandColors.primary[500],
        checkedBorderColor: BrandColors.primary[500],
        checkedHoverBorderColor: BrandColors.primary[600],
    },
};
